export default () => ({
    isLoggedIn: false,
    userData: null,
    permissions: [],
    loginWith: 'phone',
    awaitingOTP: false,
    user: null,
    manpowerType: null
});
